export default __webpack_public_path__ + "static/media/Stock-BuyBack-New.fbb38a09.svg";